import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import 'draft-js/dist/Draft.css';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Popover from '@mui/material/Popover';
import Tooltip from '@mui/material/Tooltip';

import SortFields from '../SortFields';

import useColorSystem from '../../../hook/useColorSystem';

import { HelpOutlineIcon, EditOutlinedIcon, HighlightOffIcon } from '../../../constants/images';

import theme from '../../../theme';


const fieldsBlockHeightL = '600px';

const TaboolaFieldsSelected = ({
  allOptionFields,
  selectedOptionFields,
  setSelectedOptionFields,
  currenOptionFields,
  setCurrenOptionFields,
  excelSheetSelected,
  updateSortFields,
  setUpdateSortFields,
  handleDeleteFields
}) => {
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();
  const [anchorEl, setAnchorEl] = useState(null);
  const popOpen = Boolean(anchorEl);

  const getOriginalFieldName = (allFields, name) => {
    const target = _.flatMap(allFields, item => {
      return _(item.child).filter({ expression: name }).value()
    })[0];

    return target.name;
  }

  const updateFields = (origiFields, sortFields) => {
    return origiFields
      .map((field) => {
        const matchField = _.find(sortFields, { expression: field.expression });
        if (matchField) {
          return { ...field, indexNumber: matchField.indexNumber };
        } else {
          return { ...field, indexNumber: null };
        }
      })
      .sort((a, b) => {
        if (a.indexNumber === null) return 1;
        if (b.indexNumber === null) return -1;
        return a.indexNumber - b.indexNumber;
      })
  }

  const handleUpdateSortFields = (sortFields) => {
    if (!sortFields || sortFields.length === 0) return;
    const updateGeneralField = updateFields(selectedOptionFields, sortFields);
    setSelectedOptionFields(updateGeneralField);
  }

  const closeOptionFieldsName = () => {
    setAnchorEl(null);

    if (currenOptionFields.name === '') return;

    setSelectedOptionFields(prev => {
      return prev.map(el => {
        if (el.expression === currenOptionFields.expression) {
          el.name = currenOptionFields.name;
        }
        return el;
      })
    })

    setCurrenOptionFields(null);
  }

  return (

    <Box sx={{ flex: 1 }} >
      <Box sx={{ padding: '16px 16px 4px' }} >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            paddingBottom: '4px',
            borderBottom: `1px solid ${theme.palette.grey.w300}`
          }}
        >
          <Typography>
            已選欄位
            <Tooltip title="點擊編輯圖示後可更改欄位名稱" placement="bottom-start">
              <HelpOutlineIcon
                variant="dark"
                sx={{
                  top: '2px',
                  width: '16px',
                  height: '16px',
                  marginLeft: '4px',
                }}
              />
            </Tooltip>
          </Typography>

          <SortFields
            media="TABOOLA"
            allfields={selectedOptionFields}
            excelSheetSelected={excelSheetSelected}
            updateSortFields={updateSortFields}
            setUpdateSortFields={setUpdateSortFields}
            handleUpdateSortFields={handleUpdateSortFields}
          />
        </Box>
      </Box>

      <Box
        sx={{
          height: fieldsBlockHeightL,
          overflow: 'auto',
          padding: '8px 16px 0',
          transition: 'all .5s',
        }}
      >
        {selectedOptionFields.length > 0 &&
          selectedOptionFields.map(el => {
            return (
              <Box
                key={el.expression}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '8px',
                  padding: '4px 8px 4px 4px',
                  border: `1px solid ${theme.palette.grey.w300}`,
                  borderRadius: '4px'
                }}
              >
                <HighlightOffIcon
                  variant="dark"
                  sx={{
                    marginRight: '4px',
                    '&:hover': {
                      color: mainColor,
                      cursor: 'pointer'
                    }
                  }}
                  onClick={(e) => handleDeleteFields(e, el, 'cancelField')}
                />

                <Typography
                  sx={{
                    flex: 1,
                    marginRight: '8px',
                    borderRight: `1px solid ${theme.palette.grey.w300}`,
                  }}
                >{el.name}</Typography>

                <EditOutlinedIcon
                  variant="dark"
                  sx={{
                    '&:hover': {
                      color: mainColor,
                      cursor: 'pointer'
                    }
                  }}
                  onClick={(e) => {
                    setAnchorEl(e.currentTarget);
                    setCurrenOptionFields(el);
                  }}
                />

              </Box>
            )
          })
        }
        {currenOptionFields &&
          <Popover
            open={popOpen}
            anchorEl={anchorEl}
            onClose={closeOptionFieldsName}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <Box
              sx={{
                width: '340px',
                padding: '16px'
              }}
            >
              <Typography variant="caption">
                請輸入自訂名稱
              </Typography>
              <TextField
                variant="standard"
                id="customOptionalFieldName"
                name="customOptionalFieldName"
                value={currenOptionFields.name}
                onChange={(e) => {
                  setCurrenOptionFields(prev => ({ ...prev, name: e.target.value }))
                }}
                fullWidth
              />
              <Typography
                variant="caption"
                sx={{
                  color: theme.palette.grey.w600
                }}
              >
                來源欄位：{getOriginalFieldName(allOptionFields, currenOptionFields.expression)}
              </Typography>
            </Box>

          </Popover>
        }
      </Box>
    </Box>
  )
}

export default TaboolaFieldsSelected;